/**
 * 用于跨页面 跨组件传值
 */
const TYPES = {
    UPDATE_INDEX_OPTION: 'UPDATE_INDEX_OPTION', //页面更新
	UPDATE_URL: 'UPDATE_URL', //跳转路径修改
}

const state = {
    data:{
        upDynamic: false,
    },
	url:''
}

// actions
const actions = {
    // update home pop-up information
    upDynamic({
        commit
    }, number) {
        commit(TYPES.UPDATE_INDEX_OPTION, number);
    },
	upUrl({
	    commit
	}, number) {
	    commit(TYPES.UPDATE_URL, number);
	}
};

// mutations
const mutations = {
    [TYPES.UPDATE_INDEX_OPTION](state, number) {
        state.data = number;
    },
	[TYPES.UPDATE_URL](state, number) {
	    state.url = number;
	}
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
